import { render, staticRenderFns } from "./AnsImageSetting.vue?vue&type=template&id=4119ddd4&scoped=true"
import script from "./AnsImageSetting.vue?vue&type=script&lang=js"
export * from "./AnsImageSetting.vue?vue&type=script&lang=js"
import style0 from "./AnsImageSetting.vue?vue&type=style&index=0&id=4119ddd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4119ddd4",
  null
  
)

export default component.exports